// State
// =============================================================================

const INITIAL_STATE = {
  isLoadingDownloadCheck: false,
  isLoadingPrintCheck: false,
  unitToken: ''
};
export const createState = (state = {}) => ({
  ...INITIAL_STATE,
  ...state
});